import { BASE_URL } from '../utils/apiUtils';
import { HttpService } from './HttpService';

export const OfficeInformationService = () => {
	const { get, put } = HttpService();

	const getOfficeInformation = (clerkId) => {
		const url = `${BASE_URL}/api/office-settings/office/office-information?officeId=${clerkId}`;
		return get(url, 'getOfficeInformation', {});
	};

	const putOfficeInformation = (clerkId, body) => {
		const url = `${BASE_URL}/api/office-settings/office/office-information?officeId=${clerkId}`;
		return put(url, body, 'putOfficeInformation', {});
	};

	return {
		getOfficeInformation,
		putOfficeInformation
	};
};
